import '.ah{position:fixed;}.ssr-plugin'
import '.ac{z-index:2;}.ssr-plugin'
import '.d5{inset:0px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.a6{position:absolute;}.ssr-plugin'
import '.ar{pointer-events:none;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.ce{top:0px;}.ssr-plugin'
import '.ae{left:0px;}.ssr-plugin'
import '.cf{right:0px;}.ssr-plugin'
import '.bu{display:none;}.ssr-plugin'
import '.i{height:100%;}.ssr-plugin'
import '.g4{inset:0px;}.ssr-plugin'
import '.ep{z-index:1;}.ssr-plugin'
import '.dn{top:50%;}.ssr-plugin'
import '.do{transform:translateY(-50%);}.ssr-plugin'
import '.dp{right:0px;}.ssr-plugin'
import '.dq{left:0px;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.dr{height:72px;}.ssr-plugin'
import '.ds{width:72px;}.ssr-plugin'
import '.ak{margin:0 auto;}.ssr-plugin'
import '.ab{border-radius:50%;}.ssr-plugin'
import '.dt{border:none;}.ssr-plugin'
import '.cp{max-width:480px;}.ssr-plugin'
import '.g5{margin-top:48px;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import '.g6{padding:48px;}.ssr-plugin'
import '.g7{padding-right:102px;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.bd{gap:24px;}.ssr-plugin'
import '.g8{pointer-events:auto;}.ssr-plugin'
import '.g9{text-align:right;}.ssr-plugin'
import { useState, useEffect } from 'react'
import { styled } from 'inlines'
import { Video } from 'excelsis-video'
import { colors } from '../utils/colors.js'
import { Layout } from './Layout.js'
import { Button } from './Button.js'
import { IconButton } from './IconButton.js'
import { MenuVotingRegion } from './MenuVotingRegion.js'
import { Logo } from '../assets/svg/Logo.js'
import { Icon } from '../assets/icons/index.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { SelectLanguageModal } from './SelectLanguageModal.js'
import { SelectVotingRegionModal } from './SelectVotingRegionModal.js'
import { Meter } from './Meter.js'
import { MOBILE, TABLET } from '../utils/breakpoints.js'
import { Background } from './Background.js'
import { useDictionary } from '../hooks/useDictionary.js'

type RecapVideoProps = {
  src: string
  setWatchedRecap: (x: boolean) => void
}

export const RecapVideo = ({ src, setWatchedRecap }: RecapVideoProps) => {
  const [remainingTime, setRemainingTime] = useState(0)
  const [progress, setProgress] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [hasEnded, setHasEnded] = useState(false)

  const [openLangMenu, setOpenLangMenu] = useState(false)
  const [openLangSelectModal, setOpenLangSelectModal] = useState(false)
  const [openRegionModal, setOpenRegionModal] = useState(false)

  const {
    recapProceedToVoting,
    recapStartVideo,
    continueButton,
    recapWatchVideo,
  } = useDictionary()

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  if (hasEnded) setWatchedRecap(true)

  return (
    <div className="ah ac d5 o p"
      style={{
        background: colors.secondary,}}
    >
      <Layout
        style={{
          justifyContent: 'flex-end',
          padding: 0,
          [TABLET]: {
            padding: '48px',
            justifyContent: 'center',
          },
          [MOBILE]: {
            padding: '24px',
          },
        }}
      >
        <Video
          // @ts-ignore
          playsInline
          // @ts-ignore
          onEnded={() => {
            setHasEnded(true)
            setIsPlaying(false)
          }}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
          onTimeUpdate={(e: React.SyntheticEvent<HTMLVideoElement>) => {
            const video = e.currentTarget
            const remaining = Math.ceil(video.duration - video.currentTime)
            setRemainingTime(remaining)
            if (video.duration) {
              setProgress((video.currentTime / video.duration) * 100)
            }
          }}
          autoPlay={!hasEnded}
          src={src}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 0,
            zIndex: 0,
            '& video': {
              objectFit: 'cover',
            },
            [TABLET]: {
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '24px',
              maxWidth: '696px',
              margin: '0 auto',
              '& video': {
                zIndex: 1,
              },
            },
          }}
        >
          <styled.div className="a6 ar a ce ae cf"
            style={{
              height: isPlaying ? '25vh' : '100vh',
              background: !isPlaying
                ? transparentColor(colors.secondary, 0.75)
                : `linear-gradient(180deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,
              [TABLET]: {
                height: '25vh',
                background: `linear-gradient(180deg, ${transparentColor(colors.secondary, 1)} 0%, ${transparentColor(colors.secondary, 0)} 100%)`,
              },
            }}
          />

          {!isPlaying && (
            <styled.div className="bu ar a i a6 g4 ep"
              style={{
                background: transparentColor(colors.secondary, 0.5),
                [TABLET]: {
                  display: 'block',
                },
              }}
            />
          )}
          {!isPlaying && (
            <div className="a6 dn do dp dq o v bb p ep"
              style={{
                pointerEvents: hasEnded ? 'auto' : 'none',}}
            >
              {!hasEnded && (
                <styled.button className="dr ds o v bb ak ab ar dt"
                  style={{
                    background: colors.white,
                    '&svg': { width: '90px' },
                    [MOBILE]: {
                      height: '56px',
                      width: '56px',
                    },
                  }}
                >
                  <Icon
                    type="playIcon"
                    color={colors.secondary}
                    style={{ width: 34, height: 34 }}
                  />
                </styled.button>
              )}
              <styled.p className="cp g5 aw"
                style={{
                  [TABLET]: {
                    display: 'none',
                  },
                }}
              >
                {hasEnded ? recapProceedToVoting : recapStartVideo}
              </styled.p>
              {hasEnded && (
                <Button
                  style={{
                    marginTop: 32,
                    [TABLET]: { display: 'none' },
                  }}
                  trailIcon={
                    <Icon type="forwardIcon" color={colors.secondary} />
                  }
                  onClick={() => setWatchedRecap(true)}
                >
                  {continueButton}
                </Button>
              )}
            </div>
          )}
          {isPlaying && (
            <Video.TimeLine
              style={{
                display: 'none',
                pointerEvents: 'none',
                position: 'absolute',
                width: '100%',
                zIndex: 1,
                bottom: 6,
                height: 4,
                left: 0,
                right: 0,
                [TABLET]: {
                  display: 'block',
                },
                [MOBILE]: {
                  bottom: '0px',
                },
              }}
            />
          )}

          <Video.SoundButton
            style={{
              position: 'absolute',
              top: 52,
              right: 48,
              width: 32,
              height: 32,
              borderRadius: 16,
              zIndex: 5,
              background:
                'linear-gradient(0deg, var(--White, rgba(255, 255, 255, 0.25)) 0%, var(--White, rgba(255, 255, 255, 0.25)) 100%)',
              [TABLET]: {
                top: '16px',
                right: '16px',
              },
              [MOBILE]: {
                top: '12px',
                right: '12px',
              },
            }}
            soundOffIcon={<Icon type="volumeOffIcon" />}
            soundOnIcon={<Icon type="volumeIcon" />}
          />
        </Video>

        <styled.p className="cp g5 bu aw"
          style={{
            [TABLET]: {
              display: 'block',
            },
            [MOBILE]: {
              marginTop: '20px',
            },
          }}
        >
          {hasEnded ? recapProceedToVoting : recapStartVideo}
        </styled.p>

        {hasEnded && (
          <Button
            style={{
              display: 'none',
              [TABLET]: {
                display: 'flex',
                marginTop: 24,
              },
              [MOBILE]: {
                marginTop: 16,
              },
            }}
            trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
            onClick={() => setWatchedRecap(true)}
          >
            {continueButton}
          </Button>
        )}

        <styled.nav className="a6 ce ae cf g6 g7 am v ar"
          style={{
            display: !isPlaying ? 'none' : 'flex',
            [TABLET]: {
              display: 'flex',
              padding: '24px',
            },
          }}
        >
          <IconButton
            id="#menu-button"
            icon={<Icon type="globeIcon" style={{ pointerEvents: 'none' }} />}
            onClick={() => {
              setOpenLangMenu(!openLangMenu)
            }}
            style={{ pointerEvents: 'auto' }}
          />
          <Logo
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
            }}
            width={95}
            height={32}
          />
          <div className="o v bd g8"
          >
            <styled.p className="subtext g9"
              style={{
                [TABLET]: {
                  display: 'none',
                },
              }}
            >
              {recapWatchVideo}
            </styled.p>
            <Meter value={progress} style={{ maxWidth: 72 }} />
          </div>
        </styled.nav>
      </Layout>
      {openLangMenu && (
        <MenuVotingRegion
          id="#menu-button-recap"
          triggerId="#menu-button"
          setOpen={setOpenLangMenu}
          setOpenLangSelectModal={setOpenLangSelectModal}
          setOpenRegionModal={setOpenRegionModal}
          style={{
            top: 96,
            left: 48,
            [MOBILE]: {
              top: '56px',
              left: '16px',
              right: '16px',
              maxWidth: 'unset',
              width: 'auto',
            },
          }}
        />
      )}
      {openLangSelectModal && (
        <SelectLanguageModal setModal={setOpenLangSelectModal} />
      )}
      {openRegionModal && (
        <SelectVotingRegionModal setModal={setOpenRegionModal} />
      )}
      <Background type="onboarding" motion={1} style={{ background: 'red' }} />
    </div>
  )
}
